import React from "react";
import { Box, Typography, Grid, Paper, Stack } from "@mui/material";
import {
  Scale as WeightIcon,
  DirectionsRun as RunningIcon,
} from "@mui/icons-material";
import useWaterUnit from "../hooks/useWaterUnit";

const NutritionDetails = ({ healthData }) => {
  const { waterLabel } = useWaterUnit();
  if (!healthData?.reportData) return null;

  const { reportData } = healthData;
  const fiber =
    typeof reportData?.micronutrients?.fiber === "number"
      ? reportData.micronutrients.fiber
      : 0;

  return (
    <Box sx={{ mt: 3 }}>
      <Typography variant="h6" fontWeight="bold" sx={{ mb: 2 }}>
        Nutrition Details
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <Paper sx={{ p: 2 }}>
            <Typography variant="body2" color="text.secondary">
              Proteins
            </Typography>
            <Typography variant="h6" fontWeight="bold">
              {Math.round(reportData.proteins || 0)}g
            </Typography>
          </Paper>
        </Grid>
        <Grid item xs={6}>
          <Paper sx={{ p: 2 }}>
            <Typography variant="body2" color="text.secondary">
              Carbs
            </Typography>
            <Typography variant="h6" fontWeight="bold">
              {Math.round(reportData.carbs || 0)}g
            </Typography>
          </Paper>
        </Grid>
        <Grid item xs={6}>
          <Paper sx={{ p: 2 }}>
            <Typography variant="body2" color="text.secondary">
              Fats
            </Typography>
            <Typography variant="h6" fontWeight="bold">
              {Math.round(reportData.fats || 0)}g
            </Typography>
          </Paper>
        </Grid>
        <Grid item xs={6}>
          <Paper sx={{ p: 2 }}>
            <Typography variant="body2" color="text.secondary">
              Water
            </Typography>
            <Typography variant="h6" fontWeight="bold">
              {waterLabel(reportData.water || 0)}
            </Typography>
          </Paper>
        </Grid>
        <Grid item xs={6}>
          <Paper sx={{ p: 2 }}>
            <Typography variant="body2" color="text.secondary">
              Fiber
            </Typography>
            <Typography variant="h6" fontWeight="bold">
              {fiber > 0 ? `${Math.round(fiber * 10) / 10}g` : "0g"}
            </Typography>
          </Paper>
        </Grid>
        <Grid item xs={12}>
          <Paper sx={{ p: 2 }}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Stack alignItems="center" spacing={0.5}>
                  <RunningIcon color="action" fontSize="small" />
                  <Typography variant="body2" color="text.secondary">
                    Steps
                  </Typography>
                  <Typography variant="h6" fontWeight="bold">
                    {Math.round(reportData.steps || 0).toLocaleString()}
                  </Typography>
                </Stack>
              </Grid>
              <Grid item xs={6}>
                <Stack alignItems="center" spacing={0.5}>
                  <WeightIcon color="action" fontSize="small" />
                  <Typography variant="body2" color="text.secondary">
                    Weight
                  </Typography>
                  <Typography variant="h6" fontWeight="bold">
                    {Math.round(reportData.weight || 0)} lbs
                  </Typography>
                </Stack>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default NutritionDetails;
